import newsSection from "../components/newsSection/locals/en.json";

export default {
  newsSection,
};
